import {ClipPath, Defs, G, Path, Rect, Svg} from 'react-native-svg';

const DropdownArrowIcon = () => (
  <Svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <G ClipPath="url(#clip0_168_3309)">
      <Path d="M3 4L6 1L9 4" stroke="#8E8E93" strokeWidth="1.25" strokeLinecap="square" />
      <Path d="M9 8L6 11L3 8" stroke="#8E8E93" strokeWidth="1.25" strokeLinecap="square" />
    </G>
    <Defs>
      <ClipPath id="clip0_168_3309">
        <Rect width="12" height="12" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default DropdownArrowIcon;
